import { render, staticRenderFns } from "./ModalSelecionarCarsSobrepostos.vue?vue&type=template&id=40e95fb8&scoped=true&lang=pug"
import script from "./ModalSelecionarCarsSobrepostos.vue?vue&type=script&lang=js"
export * from "./ModalSelecionarCarsSobrepostos.vue?vue&type=script&lang=js"
import style0 from "./ModalSelecionarCarsSobrepostos.vue?vue&type=style&index=0&id=40e95fb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e95fb8",
  null
  
)

export default component.exports